var map = {
	"./badesee-petershagen/assets/favicon/badesee-petershagen.webp": [
		12322,
		2322
	],
	"./demo/assets/favicon/demo.webp": [
		25634,
		5634
	],
	"./dhu/assets/favicon/dhu.webp": [
		81968,
		1968
	],
	"./kolula/assets/favicon/kolula.webp": [
		79590,
		9590
	],
	"./neuland/assets/favicon/neuland.webp": [
		37764,
		7764
	],
	"./seezeit/assets/favicon/seezeit.webp": [
		48340,
		8340
	],
	"./solheimsviken/assets/favicon/solheimsviken.webp": [
		61920,
		1920
	],
	"./strandbad-pertisau/assets/favicon/strandbad-pertisau.webp": [
		73934,
		3934
	],
	"./vonovia/assets/favicon/vonovia.webp": [
		42678,
		2678
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 54252;
module.exports = webpackAsyncContext;